import { contactData } from '@/mocks/homeData';

export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="max-w-xl mx-auto text-center">
          <h2 className="text-xl md:text-2xl lg:text-3xl font-heading font-bold text-foreground-950 mb-3">
            {contactData.title}
          </h2>
          <p className="text-sm text-foreground-500 mb-1">{contactData.subtitle}</p>
          <p className="text-sm text-foreground-600 leading-relaxed mb-8">
            {contactData.description}
          </p>
          <div className="bg-background-50 rounded-xl p-6 space-y-4">
            <div className="flex items-center gap-3 justify-center">
              <div className="w-9 h-9 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0">
                <i className="ri-mail-line text-primary-600"></i>
              </div>
              <span className="text-sm text-foreground-800 font-medium">{contactData.email}</span>
            </div>
            <div className="flex items-center gap-3 justify-center">
              <div className="w-9 h-9 rounded-lg bg-accent-100 flex items-center justify-center flex-shrink-0">
                <i className="ri-global-line text-accent-600"></i>
              </div>
              <span className="text-sm text-foreground-800 font-medium">{contactData.weibo}</span>
            </div>
            <div className="flex items-center gap-3 justify-center">
              <div className="w-9 h-9 rounded-lg bg-secondary-100 flex items-center justify-center flex-shrink-0">
                <i className="ri-message-3-line text-secondary-600"></i>
              </div>
              <span className="text-sm text-foreground-800 font-medium">{contactData.wechat}</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}